export default __webpack_public_path__ + "static/media/logo.c1f19555.svg";